import App from 'app/app.js';
import { isChristmas } from '@app/utils/dates';
import { PICTURE_DAY_TBD } from '@app/core/constants';

function LtPictureDayDateDirective($filter) {
  return {
    restrict: 'E',
    replace: true,
    scope: true,
    link: function linkFn(scope, element, attrs) {
      const result = calculateDateResult($filter, attrs);
      element.html(result);
    }
  };
}

function calculateDateResult($filter, { startdate, enddate }) {
  if (isChristmas(startdate) || isChristmas(enddate)) {
    return PICTURE_DAY_TBD;
  }

  const start = $filter('date')(startdate, 'MMMM d, yyyy', 'UTC');
  const end = $filter('date')(enddate, 'MMMM d, yyyy', 'UTC');
  const diffDay = new Date(enddate) - new Date(startdate);

  return diffDay ? `${start} - ${end}` : start;
}

App.directive('ltPictureDayDate', ['$filter', LtPictureDayDateDirective]);
